import { PackageData, PackageLinksData } from '../../packages/packagesGrid/types';
import { NetworkGridAppExternalParams } from '../../networkV2/networkAppContainer/helpers/types';
import { AlertsNavigationParams, RiskManagementNavigationParams } from '@nirvana/shared/navigation';

export interface GetDownloadLinkResponse {
  downloadLink: string;
}

export interface GetDownloadLinkRequest {
  platform: number;
}

export interface GetDefaultEndpointPackageAndLinksRequest {
  companyId: string;
}

export interface GetDefaultEndpointPackageAndLinksResponse {
  package: PackageData;
  links: PackageLinksData;
}

export enum OverviewEvents {
  INSTALL_NOW = 'installNow',
  SEND_DOWNLOAD_LINKS = 'sendDownloadLinks',
}

export enum OsTypes {
  WINDOWS = 3,
  LINUX = 4,
  MAC_OS = 6,
}

export type OverviewNavigationParams =
  | NetworkGridAppExternalParams
  | RiskManagementNavigationParams
  | AlertsNavigationParams;
